import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#000000',
    },
    lottieAnimatedView: {
        width: 250,
        height: 250,
        backgroundColor: '#000000',
    },
});

export default styles;
